import { StyleSheet } from 'react-native';
import theme from '@/constants/colors';

export default StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.backgroundPrimary,
  },
  content: {
    padding: 16,
    paddingBottom: 40,
  },
  card: {
    backgroundColor: theme.backgroundSecondary,
    borderRadius: 12,
    padding: 16,
    marginBottom: 16,
  },
  statusRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 12,
  },
  statusText: {
    flex: 1,
  },
  statusTextTitle: {
    fontSize: 16,
    fontWeight: '700',
    marginBottom: 4,
  },
  statusTextBody: {
    fontSize: 14,
    color: theme.textPrimary,
    lineHeight: 20,
  },
  optimizeButton: {
    backgroundColor: theme.backgroundPrimary,
    borderRadius: 12,
    paddingVertical: 14,
    paddingHorizontal: 20,
    marginBottom: 16,
    alignItems: 'center',
  },
  optimizeButtonText: {
    color: theme.accentPrimary,
    fontSize: 16,
    fontWeight: '600',
  },
  cardTitle: {
    fontSize: 16,
    fontWeight: '700',
    marginBottom: 8,
    color: theme.accentPrimary,
  },
  cardBody: {
    fontSize: 14,
    color: theme.textPrimary,
    lineHeight: 20,
    marginBottom: 8,
  },
  stepsList: {
    gap: 6,
  },
  stepText: {
    fontSize: 13,
    color: theme.textPrimary,
    lineHeight: 18,
  },
  recheckButton: {
    backgroundColor: theme.accentPrimary,
    borderRadius: 12,
    paddingVertical: 12,
    paddingHorizontal: 20,
    marginBottom: 16,
    alignItems: 'center',
  },
  recheckButtonText: {
    color: theme.backgroundPrimary,
    fontSize: 14,
    fontWeight: '600',
  },
});